import React from 'react';
import styled from 'styled-components';

import Card from 'antd/es/card';
import Divider from 'antd/es/divider';

import TotalCphGauge from 'components/charts/TotalCphGauge';
import PersonCphGauge from 'components/charts/PersonCphGauge';

const DCCard = styled(Card)`
  background: #FFFFFF;
  border: none;
  border-radius: 8px;
  height: calc(100% - 24px);

  & .ant-card-body {
    padding: 0;
    margin: 0;
    min-height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

const ChartWrapper = styled.div`
  padding-bottom: 16px;

  & .ant-statistic {
    margin-top: -28px;
    margin-left: -1px;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  & .ant-statistic-title {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #828C94;
  }

  & .ant-statistic-content-value {
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    color: #232526;
  }
`;

const ChartDivider = styled(Divider)`
  align-self: center;
  border-left: 1px solid #E4E8ED;
  height: 150px;
`;

const DCStatsCard = ({ className, style, totalCph, personCph }) => {
  const [totalCphVal, totalCphMax] = totalCph;
  const [personCphVal, personCphMax] = personCph;

  return (
    <DCCard className={className} style={style}>
      <ChartWrapper>
        <TotalCphGauge value={totalCphVal} max={totalCphMax} config={{ width: 180, height: 160 }} />
      </ChartWrapper>
      <ChartDivider type="vertical" />
      <ChartWrapper>
        <PersonCphGauge value={personCphVal} max={personCphMax} config={{ width: 180, height: 160 }} />
      </ChartWrapper>
    </DCCard>
  );
};

export default DCStatsCard;
